import  { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { Route, Routes} from 'react-router-dom';
import Login from './auth/login/Login';
import ManageEmployee from './manage-employee/ManageEmployee';
import Header from './header/Header';
import Dashboard from './dashboard/Dashboard';
import './App.css';
import Sidebar from './sidenav/Sidenav';
import Roles from './roles/Roles';
import Specialisation from './specialisation/SpecializationMobile';
import Skills from './skills/Skills';
import { useNavigate } from 'react-router-dom';
import Stages from './stage/Stages';
import Mission from './mission/Mission';
import Profile from './profile/Profile';
import Experiment from './experiment/experiment';
import Labs from './lab/lab';
import Subscriptions from './subscription/subscriptions'
import Inquiries from './inquiries/Inquiries'
import ExperimentReport from './experimentReport/ExperimentReport';
import BattleReport from './battle-report/BattleReport';
import WarReport from './war-report/WarReport';
import SkillReport from './skill-report/SkillReport';
import UserCart from './cart/UserCart';
import BulkLogin from './bulkLogin/BulkLogin';
import SummerCamp from './summerCamp/summerCamp';
import RegisterCamp from './summerCamp/registerCamp';
import QrCode from './qrCode/QRCode';
import Institute from './Institute/Institute';
import ReactGA from 'react-ga4'
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ManualLoader from './Components/ManualLoader/ManualLoader';
import FinanceTab from './finance-tab/financeTab';
import UserExperimentReport from './user-experiment-report/UserExperimentReport'
import Report from './experimentReport/Report';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import ReportTab from './report-tab/ReportTab';
import { useLocalStorage } from '@uidotdev/usehooks';
import BlogsCategories from './Blogs/BlogCategories';
import Blogs from './Blogs/Blogs';
import Testimonials from './Testimonials/testimonials';
import isDesktop from './isDesktop';
import ExpKeyMobile from './ExperimentKey/ExpKeyMobile';
import LabsSeo from './labs-seo/LabsSeo';
import LearnPage from './learn/LearnPage';
import BusinessEnquiries from './business-inquiries/BusinessEnquiries';
import Rewards from "./Rewards/Brands"
import Voucher from './Rewards/Voucher';
import Offers from './offers/Offers';
import GenerateQuestions from './generate-questions/GenerateQuestions';
import ReviewQuestions from './review-questions/ReviewQuestions';
import PlanSelection from './planSelected/PlanSelection';
import UserRewards from './user-rewards/UserRewards';
import LoginAnalytics from './analytics/LoginAnalytics';
import DoubtChat from './doubt-chat/DoubtChat';

// ===== Safe JWT helpers (HARDENED) =====
const isLikelyJWT = (str) => {
  if (typeof str !== 'string') return false;
  const s = str.trim();
  return s.split('.').length === 3 && !s.startsWith('{') && !s.startsWith('[');
};

const unwrapQuoted = (raw) => {
  if (typeof raw !== 'string') return raw;
  const s = raw.trim();
  if (s.startsWith('"') && s.endsWith('"')) {
    try { return JSON.parse(s); } catch { return s.slice(1, -1); }
  }
  return s;
};

const getCleanToken = (raw) => {
  if (raw == null) return null;
  let t = unwrapQuoted(String(raw).trim());
  if (!t || t === 'null' || t === 'undefined') return null;
  if (t.startsWith('Bearer ')) t = t.slice(7).trim();
  return isLikelyJWT(t) ? t : null;
};

const tryDecode = (maybeToken) => {
  const t = getCleanToken(maybeToken);
  if (!t) return null;
  try { return jwtDecode(t); } catch { return null; }
};

// ===== PRE-FLIGHT SANITIZER (runs before anything renders) =====
// If a bad token is in storage, remove it to prevent any other module that
// still uses jwtDecode directly from crashing the bundle.
(() => {
  try {
    const raw = localStorage.getItem('token');
    const cleaned = getCleanToken(raw);
    if (!cleaned) {
      localStorage.removeItem('token');
    }
  } catch {}
})();
// ===== End helpers/sanitizer =====

const TRACKING_ID = "G-Q1BG1GNPE9";
ReactGA.initialize(TRACKING_ID);

axios.defaults.withCredentials = true;

const withAuth = (Component) => {
  const AuthHoc=(props) => {
    const [token,setToken] = useLocalStorage('token',null);
    
    useEffect(() => {
      if (token) {
        const decodedJwt = tryDecode(token);
        const now = Date.now();
        if (!decodedJwt || (decodedJwt.exp && decodedJwt.exp * 1000 < now)) {
          setToken(null);
          localStorage.removeItem('token');
          window.location.href = '/';
          return;
        }
      }
      if (!token) {
        window.location.href = '/';
      }
    }, [token, setToken]);

    return token ? 
      <ManualLoader>
        <Component {...props} />
      </ManualLoader> 
      : null;
  };

  return AuthHoc;
};

const AuthenticatedManageEmployee = withAuth(ManageEmployee);
const AuthenticatedInstitute = withAuth(Institute);
const AuthenticatedDashboard = withAuth(Dashboard);
const AuthenticatedRoles = withAuth(Roles);
const AuthenticatedSpecialisation = withAuth(Specialisation);
const AuthenticatedSkills = withAuth(Skills);
const AuthenticatedStages = withAuth(Stages);
const AuthenticatedMission = withAuth(Mission);
const AuthenticatedProfile = withAuth(Profile);
const AuthenticatedExperiment = withAuth(Experiment);
const AuthenticatedLab = withAuth(Labs);
const AuthenticatedSubscriptions = withAuth(Subscriptions);
const AuthenticatedInquiries = withAuth(Inquiries);
const AuthenticatedExperimentReport = withAuth(ExperimentReport);
const AuthenticatedBattleReport = withAuth(BattleReport);
const AuthenticatedWarReport = withAuth(WarReport);
const AuthenticatedSkillReport = withAuth(SkillReport);
const AuthenticatedUserCart = withAuth(UserCart);
const AuthenticatedBulkLogin = withAuth(BulkLogin);
const AuthenticatedSummerCamp = withAuth(SummerCamp);
const AuthenticatedRegisterCamp = withAuth(RegisterCamp);
const AuthenticatedQrCode = withAuth(QrCode);
const AuthenticatedFinanceTab = withAuth(FinanceTab);
const AuthenticatedExpKey = withAuth(ExpKeyMobile);
const AuthenticatedExpReportKey = withAuth(UserExperimentReport);
const AuthenticatedReportTab = withAuth(ReportTab);
const AuthenticatedTestimonials = withAuth(Testimonials);
const AuthenticatedRewards=withAuth(Rewards)
const AuthenticatedVouchers=withAuth(Voucher)
const AuthenticatedLabsSeo = withAuth(LabsSeo);
const AuthenticatedLearnPage = withAuth(LearnPage);
const AuthenticatedBusinessEnquiries = withAuth(BusinessEnquiries);
const AuthenticatedOffers=withAuth(Offers);
const AuthenticatedGenerateQuestions = withAuth(GenerateQuestions);
const AuthenticatedReviewQuestions=withAuth(ReviewQuestions)
const AuthenticatedPlanSelection = withAuth(PlanSelection);
const AuthenticatedUserRewards = withAuth(UserRewards);
const AuthenticatedLoginAnalytics = withAuth(LoginAnalytics);
const AuthenticatedDoubtChat = withAuth(DoubtChat);

const App = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [logoutDialog,setLogoutDialog]=useState(false)
  const [isLoggedIn,setIsLoggedIn]=useState(false);
  const [token,setToken]=useLocalStorage("token",null)
  
  useEffect(() => {
    if (token) {
      const decodedJwt = tryDecode(token);
      if (!decodedJwt) {
        setIsLoggedIn(false);
        return;
      }
      const now = Date.now();
      if (decodedJwt.exp && decodedJwt.exp * 1000 < now) {
        setToken(null);
        localStorage.removeItem("token");
        setIsLoggedIn(false);
        return;
      }
      setIsLoggedIn(true);
      return;
    }
    setIsLoggedIn(false);
  }, [token, setToken]);

  const navigate=useNavigate()
  const openSidebar = () => setIsSidebarOpen(true);
  const closeSidebar = () => setIsSidebarOpen(false);

  const handleLogout=()=>{
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('tab_id');
    localStorage.removeItem('backend_tabs');
    setIsSidebarOpen(false)
    setLogoutDialog(false)
    navigate('/');
  }
  const isDesktopDevice = isDesktop();
  return (
    <>
      <div style={{height:"95%"}}>
        {isDesktopDevice && <Header onMenuClick={openSidebar} isLoggedIn={isLoggedIn} />}
        {token && token!==null && <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} setLogoutDialog={setLogoutDialog} />}
        {isLoggedIn && <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />}
        <div className="content-container" style={{height:"86%"}} >
          <Routes>
            <Route
              path="/labs/:userId/experiments/report/:attemptId"
              element={<Report />}
            />
            <Route path="" element={<Login setIsLoggedIn={setIsLoggedIn} />} />
            <Route path="/employee" element={<AuthenticatedManageEmployee />} />
            <Route path="/dashboard" element={<AuthenticatedDashboard />} />
            <Route path="/roles" element={<AuthenticatedRoles />} />
            <Route path="/specialization" element={<AuthenticatedSpecialisation />} />
            <Route path="/skills" element={<AuthenticatedSkills />} />
            <Route path="/skills/:skillId/stage" element={<AuthenticatedStages />} />
            <Route path="/skills/:skillId/stage/:stageId/mission" element={<AuthenticatedMission />} />
            <Route path="/profile" element={<AuthenticatedProfile />} />
            <Route path="/labs/:labId/experiments" element={<AuthenticatedExperiment />} />
            <Route path="/labs" element={<AuthenticatedLab />} />
            <Route path="/Subscriptions" element={<AuthenticatedSubscriptions />} />
            <Route path="/inquiries" element={<AuthenticatedInquiries />} />
            <Route path="/experiment-report" element={<AuthenticatedExperimentReport />} />
            <Route path="/battle-report" element={<AuthenticatedBattleReport />} />
            <Route path="/war-report" element={<AuthenticatedWarReport />} />
            <Route path="/skills-report" element={<AuthenticatedSkillReport />} />
            <Route path="/user-cart" element={<AuthenticatedUserCart />} />
            <Route path="/bulk-login" element={<AuthenticatedBulkLogin />} />
            <Route path="/summer-referrals" element={<AuthenticatedSummerCamp />} />
            <Route path="/register" element={<AuthenticatedRegisterCamp />} />
            <Route path="/qr-code" element={<AuthenticatedQrCode />} />       
            <Route path="/finance-tab" element={<AuthenticatedFinanceTab />} />
            <Route path="/institute" element={<AuthenticatedInstitute />} />
            <Route path="/expKey" element={<AuthenticatedExpKey />} />
            <Route path="/user-exp-report" element={<AuthenticatedExpReportKey />} />
            <Route path="/report" element={<AuthenticatedReportTab />} />
            <Route path="/blogs" element={<BlogsCategories />} />
            <Route path="/blogs/details/:catId" element={<Blogs />} />
            <Route path="/testimonials" element={<AuthenticatedTestimonials />} />
            <Route path='/rewards'  element={<AuthenticatedRewards />} />
            <Route path='/rewards/vouchers/:id' element={<AuthenticatedVouchers />} />
            <Route path='/user-rewards' element={<AuthenticatedUserRewards />} />
            <Route path="/labs-seo" element={<AuthenticatedLabsSeo />} />
            <Route path="/learn" element={<AuthenticatedLearnPage />} />
            <Route path="/business-enquiries" element={<AuthenticatedBusinessEnquiries />} />
            <Route path="/offers" element={<AuthenticatedOffers />} />
            <Route path="/generate-questions" element={<AuthenticatedGenerateQuestions />} />
            <Route path="/review-questions" element={<AuthenticatedReviewQuestions />} />
            <Route path="/plan-selected" element={<AuthenticatedPlanSelection />} />
            <Route path="/analytics/login-analytics" element={<AuthenticatedLoginAnalytics />} />
            <Route path="/doubt-chat" element={<AuthenticatedDoubtChat />} />
          </Routes>
          <ToastContainer/>
        </div>
      </div>
      <Dialog open={logoutDialog} >
        <DialogTitle>Are you sure you want to Logout</DialogTitle>
        <DialogActions>
          <Button variant='contained' color='error' onClick={handleLogout} >Yes</Button>
          <Button variant='contained' onClick={()=>{setLogoutDialog(false)}} >No</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default App;
